export enum ClaimPropertyStatusEnum {
  vacant = 'VACANT',
  occupied = 'OCCUPIED'
}
